import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import statuses from './statuses'
import tags from './tags'
import workspaces from './workspaces'
import workspaceusers from './workspaceusers'
import session from './session'
import messages from './messages'
import message from './message'
import inboxFilters from './inboxFilters'
import accounts from './accounts'
import networks from './networks'
import mobileMenu from './mobileMenu'
import htmlModals from './htmlModals'
import statistics from './statistics'
import notifications from './notifications'
import menu from './menu'
import loading from './loading'
import plans from './plans'
import subscriptions from './subscriptions'
import contacts from './contacts'

 export const store = new Vuex.Store({
	 modules:{
		 session: session,
		 messages: messages,
		 inboxFilters: inboxFilters,
		 statuses: statuses,
		 tags: tags,
		 workspaces: workspaces,
		 workspaceusers: workspaceusers,
		 accounts: accounts,
		 networks: networks,
		 mobileMenu: mobileMenu,
		 htmlModals: htmlModals,
		 statistics: statistics,
		 notifications: notifications,
		 menu: menu,
		 loading: loading,
		 plans: plans,
		 subscriptions: subscriptions,
		 message: message,
		 contacts: contacts
	 }
})


export default store





// WEBPACK FOOTER //
// ./src/store/index.js